import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import translate from 'counterpart';
import { path, pick, propOr } from 'ramda';

import { setHeaderTitle } from 'actions/appActions';

export const withRouteOptions = (WrappedComponent, title) => {
    return (
        @connect(pick(['headerTitle']), { setHeaderTitle })
        class RouteOptions extends Component {
            componentDidMount() {
                this.props.setHeaderTitle({ title: title || path(['routeOptions', 'title'], WrappedComponent) });
            }

            render() {
                const { headerTitle } = this.props;
                const title = headerTitle.title && translate(headerTitle.title, {
                    fallback: '',
                    ...propOr({}, 'params', headerTitle)
                });

                return (
                    <Fragment>
                        <Helmet>
                            <title>{title}</title>
                        </Helmet>
                        <WrappedComponent {...this.props} />
                    </Fragment>
                )
            }
        }
    );
};
